import { Link } from 'react-router-dom';
import { Plane, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-navy border-t border-white/10 pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-gold to-gold-hover flex items-center justify-center">
                <Plane className="w-5 h-5 text-navy" />
              </div>
              <span className="font-heading font-bold text-2xl text-white">
                Va<span className="text-gold">Ai</span>
              </span>
            </Link>
            <p className="text-white/60 text-sm leading-relaxed">
              Recomandări inteligente de vacanțe cu ajutorul inteligenței artificiale. 
              Descoperă ofertele perfecte pentru tine.
            </p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Categorii</h4>
            <ul className="space-y-2">
              {['Circuite', 'City Break', 'Croaziere', 'Sejururi'].map((cat) => (
                <li key={cat}>
                  <Link 
                    to={`/${cat.toLowerCase().replace(' ', '-')}`}
                    className="text-white/60 hover:text-gold transition-colors text-sm"
                  >
                    {cat}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Linkuri Rapide</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/last-minute" className="text-white/60 hover:text-gold transition-colors text-sm">
                  Last Minute
                </Link>
              </li>
              <li>
                <Link to="/early-booking" className="text-white/60 hover:text-gold transition-colors text-sm">
                  Early Booking
                </Link>
              </li>
              <li>
                <Link to="/populare" className="text-white/60 hover:text-gold transition-colors text-sm">
                  Populare
                </Link>
              </li>
              <li>
                <Link to="/termeni-si-conditii" className="text-white/60 hover:text-gold transition-colors text-sm">
                  Termeni și condiții
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-white/60 text-sm">
                <Mail className="w-4 h-4 text-gold" />
                contact@vaai.ro
              </li>
              <li className="flex items-center gap-3 text-white/60 text-sm">
                <Phone className="w-4 h-4 text-gold" />
                
              </li>
              <li className="flex items-center gap-3 text-white/60 text-sm">
                <MapPin className="w-4 h-4 text-gold" />
                București, România
              </li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="glass rounded-xl p-4 mb-8">
          <p className="text-white/50 text-xs text-center leading-relaxed">
            <strong className="text-gold">Disclaimer:</strong> VaAi recomandă oferte și redirecționează utilizatorii către site‑urile comercianților. 
            Rezervările se finalizează direct pe site-ul comerciantului. 
            Platforma nu necesită licență de turism deoarece nu intermediază rezervări sau plăți.
          </p>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} VaAi - Vacanțe AI. Toate drepturile rezervate.
          </p>
        </div>
      </div>
    </footer>
  );
};
